import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import styles from "./styles"
import { withStyles } from "@material-ui/core/styles"
import { Box, Typography, Checkbox, TextField } from "@material-ui/core/"
import { Formik, Form } from "formik"
import { CardElement } from "@stripe/react-stripe-js"
import { useDebounce } from "use-lodash-debounce"
import { checkCoupon } from "actions/organization"
import TermsAndConditions from "./TermsAndConditions.js"
const Step4Payment = ({ classes, data, options }) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const [scroll, setScroll] = useState(false)
  const [coupon, setCoupon] = useState("")
  const [couponError, setCouponError] = useState("")
  const bouncedCoupon = useDebounce(coupon, 200)
  const { formState, formSubmit, setFormRef, setFormData } = data
  useEffect(() => {
    setFormRef(formRef)
  }, [])

  const handleScroll = e => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    if (bottom) {
      setScroll(true)
    }
  }

  useEffect(() => {
    if (bouncedCoupon) {
      dispatch(checkCoupon(bouncedCoupon))
        .then(coupon => {
          if (coupon.err) {
            setCouponError(coupon.err.raw.message)
            setFormData({
              target: {
                value: null,
                name: "coupon"
              }
            })
          } else {
            setCouponError(null)
            setFormData({
              target: {
                value: coupon.coupon,
                name: "coupon"
              }
            })
          }
        })
        .catch(console.error)
    } else {
      setFormData({
        target: {
          value: null,
          name: "coupon"
        }
      })
      setCouponError("")
    }
  }, [bouncedCoupon])

  const option = options.find(x => x.id === formState.plan)

  let couponText = null
  let totalPrice = Number(option.total)

  if (formState.coupon) {
    const { amount_off: amountOff, percent_off: percentOff } = formState.coupon

    if (amountOff) {
      couponText = `- $${Number(amountOff) / 100}`
      totalPrice = Number(option.total) - Number(amountOff) / 100
    } else if (percentOff) {
      couponText = `- %${percentOff}`
      totalPrice =
        Number(option.total) - Number(option.total) * (Number(percentOff) / 100)
    }
  }
  let totalMonth = (totalPrice / 12).toFixed(2)
  return (
    <Box className={classes.subscriptionInformationContainer}>
      <Formik
        innerRef={formRef}
        initialValues={{
          agreementChecked: formState.agreementChecked
        }}
        onSubmit={formSubmit}
      >
        {formikProps => {
          const handleChange = formikProps.handleChange
          formikProps.handleChange = e => {
            handleChange(e)
            setFormData(e)
          }
          return (
            <Form ref={formRef}>
              <Box key={option.plan}>
                {!formState.groupCode ? (
                  <Box className={classes.subscriptionExplanationContainer}>
                    <Box display="flex">
                      <Box
                        className={classes.subscriptionLeftContainer}
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography
                          className={classes.optionLabel}
                          variant="h2"
                          color="secondary"
                        >
                          {option.label}
                        </Typography>
                        <Typography
                          variant="h5"
                          className={classes.membersContainer}
                        >
                          org size
                        </Typography>
                        <Typography
                          variant="body1"
                          className={classes.priceMonth}
                        >
                          ${totalMonth} / mo
                        </Typography>
                        <Typography className={classes.billedContainer}>
                          billed annually
                        </Typography>
                      </Box>
                      <Box className={classes.subscriptionRightContainer}>
                        <Typography
                          className={classes.explanationContainer}
                          variant="body1"
                        >
                          {option.explanation}
                        </Typography>
                        <Box
                          className={classes.priceExplanationContainer}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Typography
                            variant="body1"
                            className={classes.priceMonth}
                          >
                            12 Months
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.priceMonth}
                          >
                            ${totalMonth}
                          </Typography>
                        </Box>

                        {couponText && (
                          <Box display="flex" justifyContent="space-between">
                            <Typography
                              color="primary"
                              variant="subtitle2"
                              className={classes.couponText}
                            >
                              Sub Total
                            </Typography>
                            <Typography
                              color="primary"
                              variant="subtitle2"
                              className={classes.couponText}
                            >
                              $
                              {Number(option.total)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </Typography>
                          </Box>
                        )}

                        {couponText && (
                          <Box display="flex" justifyContent="space-between">
                            <Typography
                              variant="subtitle1"
                              className={classes.couponText}
                            >
                              Coupon
                            </Typography>
                            <Typography
                              color="primary"
                              variant="subtitle2"
                              className={classes.couponText}
                            >
                              {couponText}
                            </Typography>
                          </Box>
                        )}

                        <Box display="flex" justifyContent="space-between">
                          <Typography
                            color="primary"
                            variant="subtitle2"
                            className={classes.totalText}
                          >
                            Total
                          </Typography>
                          <Typography
                            color="primary"
                            variant="subtitle2"
                            className={classes.totalText}
                          >
                            $
                            {Number(totalPrice)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <TextField
                        label="Coupon Code"
                        color="primary"
                        value={coupon}
                        onChange={e => setCoupon(e.target.value)}
                        style={{ maxWidth: "150px" }}
                      />
                      <Typography>{couponError}</Typography>
                    </Box>
                  </Box>
                ) : null}
                <Box>
                  <Typography variant="h6" className={classes.agreementsTitle}>
                    Terms & Conditions
                  </Typography>
                  <Box
                    className={classes.agreementsContainer}
                    onScroll={handleScroll}
                  >
                    <TermsAndConditions />
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    className={classes.checkboxContainer}
                  >
                    {scroll ? (
                      <Checkbox
                        name="agreementChecked"
                        onChange={e => {
                          e.target.value = e.target.checked
                          formikProps.handleChange(e)
                        }}
                        checked={formikProps.values.agreementChecked}
                        color="primary"
                      />
                    ) : (
                      <Checkbox
                        disabled
                        name="agreementChecked"
                        onChange={e => {
                          e.target.value = e.target.checked
                          formikProps.handleChange(e)
                        }}
                        checked={formikProps.values.agreementChecked}
                        color="primary"
                      />
                    )}

                    <Typography
                      variant="body1"
                      className={
                        scroll
                          ? classes.agreemetnsBoxText
                          : classes.noAgreemtnsBoxText
                      }
                    >
                      I agree to the FirstLine Social Terms and Conditions
                    </Typography>
                  </Box>
                  {!formState.groupCode && (
                    <React.Fragment>
                      <Typography
                        color="primary"
                        variant="h6"
                        className={classes.paymentTitle}
                      >
                        Please enter your payment information
                      </Typography>
                      <CardElement />
                    </React.Fragment>
                  )}
                </Box>
              </Box>
            </Form>
          )
        }}
      </Formik>
    </Box>
  )
}

export default withStyles(styles)(Step4Payment)



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step4Payment/index.jsx